import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
	selector: 'rb-drap-and-drop',
	templateUrl: './drap-and-drop.component.html',
	styleUrls: ['./drap-and-drop.component.scss'],
	standalone: false,
})
export class DrapAndDropComponent {
	@ViewChild('fileDropRef', { static: false }) fileDropEl: ElementRef;
	files: any[] = [];
	@Input() maximumFiles: number = 3;
	@Input() accept: string = 'image/*';
	errorMaximumFiles: boolean = false;
	base64Files: any[] = [];

	@Output() uploadFiles: EventEmitter<any> = new EventEmitter();
	/**
	 * on file drop handler
	 */
	onFileDropped($event): void {
		this.prepareFilesList($event);
	}

	/**
	 * handle file from browsing
	 */
	fileBrowseHandler(files): void {
		this.prepareFilesList(files);
	}

	/**
	 * Delete file from files list
	 * @param index (File index)
	 */
	deleteFile(index: number): void {
		this.files.splice(index, 1);
	}

	/**
	 * Convert Files list to normal array list
	 * @param files (Files List)
	 */
	prepareFilesList(files: Array<any>): void {
		this.errorMaximumFiles = false;
		if (this.files.length + files.length > this.maximumFiles) {
			this.errorMaximumFiles = true;
		} else {
			// eslint-disable-next-line prefer-const
			for (let item of files) {
				const reader = new FileReader();
				reader.readAsDataURL(item);
				reader.onload = () => {
					this.base64Files.push(reader.result);
				};
				this.files.push(item);
			}
			this.fileDropEl.nativeElement.value = '';
		}
	}

	/**
	 * format bytes
	 * @param bytes (File size in bytes)
	 * @param decimals (Decimals point)
	 */
	formatBytes(bytes: number, decimals = 2): string | number {
		if (bytes === 0) {
			return '0 Bytes';
		}
		const k = 1024;
		const dm = decimals <= 0 ? 0 : decimals;
		const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
		const i = Math.floor(Math.log(bytes) / Math.log(k));
		return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
	}
	saveFiles(): void {
		this.uploadFiles.emit({
			files: this.files,
			base64Files: this.base64Files,
		});
		this.files = [];
		this.base64Files = [];
	}
}
